/* eslint-disable */
import { en, fi, sv } from "@messageformat/runtime/lib/cardinals";
import { plural } from "@messageformat/runtime";
export default {
  en: {
    info: {
      body: () => "Tell us your experiences on our services. This will help us improve the services.",
      alert: {
        row: {
          "1": () => "Please note that the feedback form does not handle assignments related to personal service or inquiries.",
          "2": () => "Help with personal banking or insurance matters"
        }
      },
      list: {
        item1: () => "Give a thank you.",
        item2: () => "Share your development ideas.",
        item3: () => "Tell us what we should improve."
      }
    },
    login: {
      body: () => "Your feedback can be processed faster if you log in before submitting feedback.",
      link: () => "Log into the service and give us feedback"
    },
    feedback: {
      header: () => "Feedback",
      body: () => "All fields are required, unless indicated as optional.",
      form: {
        type: {
          label: () => "This feedback is",
          options: {
            positive: () => "A thank you",
            negative: () => "A criticism",
            development_proposal: () => "An idea for improvement"
          },
          error: {
            empty: () => "Select the type of feedback."
          }
        },
        text: {
          label: () => "Feedback",
          error: {
            empty: () => "Tell us your feedback."
          },
          placeHolder: () => "Please note that the feedback form does not handle assignments related to personal transactions or inquiries"
        },
        contactCustomer: {
          form: {
            label: () => "Contact Information"
          },
          label: () => "I want to be contacted regarding my feedback",
          hint: () => "We will use your contact details only to contact you regarding your feedback, not for marketing purposes."
        },
        contactMethod: {
          label: () => "Select contact method",
          options: {
            phone: () => "Phone call",
            email: () => "Email",
            web_message: () => "Message on OP's service"
          }
        },
        phone: {
          label: () => "Phone number",
          hint: () => "Type your phone number without space characters. If you have a foreign subscription, please enter your country code.",
          error: {
            empty: () => "Enter phone number.",
            invalid: () => "Check the phone number."
          }
        },
        email: {
          label: () => "Email address",
          error: {
            empty: () => "Enter email address.",
            invalid: () => "Check the email address."
          }
        },
        reachability: {
          label: () => "What is the best time to reach you?"
        },
        customerInfo: {
          label: () => "I want to leave my name and address so that my feedback can be processed faster"
        },
        name: {
          label: () => "Name",
          error: {
            empty: () => "Enter name.",
            invalid: () => "Check the name."
          }
        },
        address: {
          label: () => "Address",
          error: {
            empty: () => "Enter address.",
            invalid: () => "Check the address."
          }
        },
        postalCode: {
          label: () => "Postcode",
          error: {
            empty: () => "Enter postcode.",
            invalid: () => "Check the postcode."
          }
        },
        moreInformation: {
          label: () => "more information"
        },
        target: {
          label: () => "The feedback concerns",
          option: {
            "default": () => "- Select -",
            banking: () => "Banking services",
            insurance: () => "Insurance services",
            other: () => "Other matter"
          },
          error: {
            empty: () => "Select what the feedback concerns."
          }
        },
        subject: {
          label: () => "Subject",
          option: {
            "default": () => "- Select -",
            accounts_cards_payments: () => "Accounts, cards and payments",
            customer_feedback_loans_finance: () => "Loans and financing services",
            customer_feedback_saving_investing: () => "Saving and investing",
            customer_service: () => "Customer service",
            customer_feedback_mobile_service: () => "Mobile service",
            customer_feedback_web_service: () => "Online service",
            communication_marketing: () => "Communications and marketing",
            customer_feedback_proprietary: () => "Owner-customer membership",
            customer_feedback_insurance_damage: () => "Insurance and claims",
            other: () => "Other",
            customer_feedback_insurance_sales_customer_service: () => "Insurance Sales and Transactions",
            customer_feedback_claims_indemnities: () => "Insurance Claims and Compensation",
            customer_feedback_insurance_saving: () => "Insurance Savings, Life and Pension Insurance"
          },
          error: {
            empty: () => "Select subject."
          }
        },
        textArea: {
          error: {
            title: () => "Check spelling. ",
            text: () => "Permitted characters are Aa‒Öö, 0‒9 and special characters . , : ? ! ' \" + - & / ( )"
          },
          srError: {
            text: () => "Permitted characters include lowercase and uppercase letters of the Finnish alphabet, digits from 0 to 9, and special characters including full stop, comma, colon, question mark, exclamation mark, apostrophe, quotation mark, plus sign, dash, ampersand, slash and brackets."
          }
        },
        optional: () => "(optional)",
        send: () => "Send",
        error: {
          row1: () => "Sending failed.",
          row2: () => "Please try again."
        },
        quit: {
          button: () => "Quit",
          modal: {
            title: () => "Do you want to quit?",
            body: () => "If you quit, the information you provided will not be saved.",
            button: {
              quit: () => "Quit",
              cancel: () => "Cancel"
            }
          }
        }
      },
      sensitiveInfo: {
        unidentifiedCustomer: () => "Do not include any personal details in the feedback, such as a personal ID code, a user ID, account numbers, card numbers or health information.",
        identifiedCustomer: () => "Do not include any personal details in the feedback, such as a personal ID code, a user ID, card numbers or health information."
      },
      errorSummary: {
        title: (d) => plural(d.count, 0, en, { one: "Please check and correct the following item", other: "Please check and correct the following " + d.count + " items" })
      }
    },
    thanks: {
      title: () => "Thank you for your feedback!",
      body: () => "We will process your feedback as soon as possible and contact you if you asked us to do so.",
      feedbackId: (d) => "For your record, your feedback ID: " + d.feedbackId + ".",
      link: () => "Go to the op.fi homepage"
    },
    quit: {
      title: () => "You stopped completing the form",
      body: () => "The information you entered was not saved.",
      link: {
        frontpage: () => "Go to the op.fi homepage",
        giveFeedback: () => "Go to the Give us feedback page"
      }
    },
    error: {
      title: () => "We are sorry, there is a disruption in our service",
      body: () => "Giving feedback is not possible temporarily. Please try again soon.",
      link: {
        form: () => "Please try again to give us feedback",
        frontpage: () => "Go to the op.fi homepage",
        reportProblem: () => "Report a problem"
      }
    },
    url: {
      thanks: () => "/thanks-for-feedback",
      error: () => "/error",
      quit: () => "/aborted",
      opfi: {
        person: () => "",
        business: () => "/web/corp/auth/front-page",
        tupas: () => "",
        unidentified: () => ""
      },
      form: {
        person: () => "/auth/customer-service/give-feedback",
        tupas: () => "/auth/customer-service/give-feedback",
        unidentified: () => "/private-customers/customer-service/give-feedback",
        business: () => "/web/corp/auth/customer-service/feedback"
      },
      reportProblem: {
        person: () => "/private-customers/customer-service/report-a-problem",
        tupas: () => "/private-customers/customer-service/report-a-problem",
        unidentified: () => "/private-customers/customer-service/report-a-problem",
        business: () => "/web/corp/auth/customer-service/report-an-error"
      },
      giveFeedback: {
        person: () => "/private-customers/customer-service/feedback-and-problems",
        business: () => "/web/corp/auth/customer-service/feedback-and-problems",
        unidentified: () => "/private-customers/customer-service/feedback-and-problems",
        tupas: () => "/private-customers/customer-service/feedback-and-problems"
      }
    },
    session: {
      "continue": {
        modal: {
          title: () => "Do you want to continue using this service? ",
          text: () => "If you don’t want to continue but you already filled in some details, we will delete all such details to protect your security.",
          ok: () => "Continue using the service",
          cancel: () => "Quit using the service"
        }
      },
      dataDeleted: {
        modal: {
          title: () => "Your session was stopped",
          text: {
            a: () => "Because you were not actively using the service for a while, your session was stopped. If you had filled in some details, all such details were deleted to protect your security.",
            b: () => "If you had filled in some details, all such details were deleted to protect your security."
          },
          close: () => "Close"
        }
      }
    }
  },
  fi: {
    info: {
      body: () => "Kerro meille kokemuksesi palveluistamme. Näin autat meitä palveluiden kehittämisessä.",
      alert: {
        row: {
          "1": () => "Huomaathan, että palautelomakkeella ei käsitellä henkilökohtaiseen asiointiin tai kyselyihin liittyviä toimeksiantoja.",
          "2": () => "Apua henkilökohtaisiin pankki- ja vakuutusasiointiin"
        }
      },
      list: {
        item1: () => "Välitä kiitoksesi.",
        item2: () => "Jaa kehitysideasi.",
        item3: () => "Kerro missä on parantamisen varaa."
      }
    },
    login: {
      body: () => "Palautteesi käsittely on sujuvampaa, jos kirjaudut ennen palautteen antamista.",
      link: () => "Kirjaudu palveluun ja anna palautetta"
    },
    feedback: {
      header: () => "Palaute",
      body: () => "Kaikki kentät ovat pakollisia, ellei toisin mainita.",
      form: {
        type: {
          label: () => "Palaute on",
          options: {
            positive: () => "Kiitos",
            negative: () => "Moite",
            development_proposal: () => "Kehitysehdotus"
          },
          error: {
            empty: () => "Valitse palautteen tyyppi."
          }
        },
        text: {
          label: () => "Palaute",
          error: {
            empty: () => "Kirjoita palaute."
          },
          placeHolder: () => "Huomaathan, että palautelomakkeella ei käsitellä henkilökohtaiseen asiointiin tai kyselyihin liittyviä toimeksiantoja"
        },
        contactCustomer: {
          form: {
            label: () => "Yhteystiedot"
          },
          label: () => "Haluan, että minuun otetaan yhteyttä palautteeseeni liittyen",
          hint: () => "Käytämme yhteystietojasi vain palautteeseen liittyvään viestintään, emme markkinointiviestintään."
        },
        contactMethod: {
          label: () => "Valitse tapa",
          options: {
            phone: () => "Puhelinsoitto",
            email: () => "Sähköposti",
            web_message: () => "Viesti OP:n palvelussa"
          }
        },
        phone: {
          label: () => "Puhelinnumero",
          hint: () => "Kirjoita puhelinnumerosi ilman välilyöntejä. Jos liittymäsi on ulkomaalainen, muista maatunnus.",
          error: {
            empty: () => "Kirjoita puhelinnumero.",
            invalid: () => "Tarkista puhelinnumero."
          }
        },
        email: {
          label: () => "Sähköpostiosoite",
          error: {
            empty: () => "Kirjoita sähköpostiosoite.",
            invalid: () => "Tarkista sähköpostiosoite."
          }
        },
        reachability: {
          label: () => "Milloin olet parhaiten tavoitettavissa?"
        },
        customerInfo: {
          label: () => "Haluan jättää nimi- ja osoitetietoni, jotta palautteeni voidaan käsitellä sujuvammin"
        },
        name: {
          label: () => "Nimi",
          error: {
            empty: () => "Kirjoita nimi.",
            invalid: () => "Tarkista nimi."
          }
        },
        address: {
          label: () => "Osoite",
          error: {
            empty: () => "Kirjoita osoite.",
            invalid: () => "Tarkista osoite."
          }
        },
        postalCode: {
          label: () => "Postinumero",
          error: {
            empty: () => "Kirjoita postinumero.",
            invalid: () => "Tarkista postinumero."
          }
        },
        moreInformation: {
          label: () => "lisätietoja"
        },
        target: {
          label: () => "Palautteen kohde",
          option: {
            "default": () => "- Valitse -",
            banking: () => "Pankkipalvelut",
            insurance: () => "Vakuutuspalvelut",
            other: () => "Muu asia"
          },
          error: {
            empty: () => "Valitse palautteen kohde."
          }
        },
        subject: {
          label: () => "Aihe",
          option: {
            "default": () => "- Valitse -",
            accounts_cards_payments: () => "Tilit, kortit ja maksut",
            customer_feedback_loans_finance: () => "Lainat ja rahoituspalvelut",
            customer_feedback_saving_investing: () => "Säästäminen ja sijoittaminen",
            customer_service: () => "Asiakaspalvelu",
            customer_feedback_mobile_service: () => "Mobiilipalvelu",
            customer_feedback_web_service: () => "Verkkopalvelu",
            communication_marketing: () => "Viestintä ja markkinointi",
            customer_feedback_proprietary: () => "Omistaja-asiakkuus",
            customer_feedback_insurance_damage: () => "Vakuutukset ja vahingot",
            other: () => "Muu",
            customer_feedback_insurance_sales_customer_service: () => "Vakuutuksen myynti ja asiointi",
            customer_feedback_claims_indemnities: () => "Vahinkoasiat ja korvaukset",
            customer_feedback_insurance_saving: () => "Vakuutussäästäminen, henki- ja eläkevakuutukset"
          },
          error: {
            empty: () => "Valitse aihe."
          }
        },
        textArea: {
          error: {
            title: () => "Tarkista kirjoitusasu.",
            text: () => "Sallittuja merkkejä ovat kirjaimet Aa–Öö, numerot 0–9 ja erikoismerkit . , : ? ! ' \" + - & / ( )"
          },
          srError: {
            text: () => "Sallittuja merkkejä ovat isot ja pienet kirjaimet a:sta ö:hön, numerot 0 viiva 9 ja erikoismerkit piste, pilkku, kaksoispiste, kysymysmerkki, huutomerkki, heittomerkki, lainausmerkki, plusmerkki, viiva, et-merkki, vinoviiva ja sulkeet."
          }
        },
        optional: () => "(vapaaehtoinen)",
        send: () => "Lähetä",
        error: {
          row1: () => "Lähetys ei onnistunut.",
          row2: () => "Ole hyvä ja yritä uudestaan."
        },
        quit: {
          button: () => "Keskeytä",
          modal: {
            title: () => "Haluatko keskeyttää?",
            body: () => "Jos keskeytät, antamiasi tietoja ei tallenneta.",
            button: {
              quit: () => "Keskeytä",
              cancel: () => "Peruuta"
            }
          }
        }
      },
      sensitiveInfo: {
        unidentifiedCustomer: () => "Älä kirjoita palautteeseen henkilökohtaisia tietoja, kuten henkilötunnusta, käyttäjätunnuksia, tilinumeroita, korttien numeroita tai terveystietoja.",
        identifiedCustomer: () => "Älä kirjoita palautteeseen henkilökohtaisia tietoja, kuten henkilötunnusta, käyttäjätunnuksia, korttien numeroita tai terveystietoja."
      },
      errorSummary: {
        title: (d) => plural(d.count, 0, fi, { one: "Tarkista ja korjaa seuraava kohta", other: "Tarkista ja korjaa seuraavat " + d.count + " kohtaa" })
      }
    },
    thanks: {
      title: () => "Kiitos palautteestasi!",
      body: () => "Käsittelemme palautteesi mahdollisimman pian ja otamme sinuun yhteyttä, jos toivoit yhteydenottoa.",
      feedbackId: (d) => "Halutessasi voit ottaa talteen palautteen numeron: " + d.feedbackId + ".",
      link: () => "Siirry op.fi:n etusivulle"
    },
    quit: {
      title: () => "Keskeytit lomakkeen täyttämisen",
      body: () => "Antamiasi tietoja ei tallennettu palveluun.",
      link: {
        frontpage: () => "Siirry op.fi:n etusivulle",
        giveFeedback: () => "Siirry Anna palautetta -sivulle"
      }
    },
    error: {
      title: () => "Häiriö palvelussa, pahoittelemme",
      body: () => "Palautteen antaminen ei juuri nyt onnistu. Ole hyvä ja yritä kohta uudestaan.",
      link: {
        form: () => "Yritä palautteen antamista uudestaan",
        frontpage: () => "Siirry op.fi:n etusivulle",
        reportProblem: () => "Ilmoita ongelmasta"
      }
    },
    url: {
      thanks: () => "/kiitos-palautteestasi",
      error: () => "/virhe",
      quit: () => "/keskeytetty",
      opfi: {
        person: () => "/auth/paivittaiset",
        business: () => "/web/corp/auth/etusivu",
        tupas: () => "/auth/paivittaiset",
        unidentified: () => ""
      },
      form: {
        person: () => "/auth/asiakaspalvelu/anna-palautetta",
        tupas: () => "/auth/asiakaspalvelu/anna-palautetta",
        unidentified: () => "/henkiloasiakkaat/asiakaspalvelu/anna-palautetta",
        business: () => "/web/corp/auth/asiakaspalvelu/palaute"
      },
      reportProblem: {
        person: () => "/auth/asiakaspalvelu/ilmoita-ongelmasta",
        tupas: () => "/auth/asiakaspalvelu/ilmoita-ongelmasta",
        unidentified: () => "/henkiloasiakkaat/asiakaspalvelu/ilmoita-ongelmasta",
        business: () => "/web/corp/auth/asiakaspalvelu/ilmoita-ongelmasta"
      },
      giveFeedback: {
        person: () => "/auth/asiakaspalvelu/palautteet-ja-ongelmat",
        business: () => "/web/corp/auth/asiakaspalvelu/palautteet-ja-ongelmat",
        unidentified: () => "/henkiloasiakkaat/asiakaspalvelu/palautteet-ja-ongelmat",
        tupas: () => "/auth/asiakaspalvelu/palautteet-ja-ongelmat"
      }
    },
    session: {
      "continue": {
        modal: {
          title: () => "Haluatko jatkaa asiointia?",
          text: () => "Jos et jatka asiointia ja ehdit täyttää jotain tietoja, poistamme kaikki tiedot oman turvallisuutesi vuoksi.",
          ok: () => "Jatka asiointia",
          cancel: () => "Keskeytä asiointi"
        }
      },
      dataDeleted: {
        modal: {
          title: () => "Asiointi keskeytetty",
          text: {
            a: () => "Koska et hetkeen käyttänyt palvelua, asiointisi keskeytettiin. Jos olit täyttänyt jotain tietoja, kaikki tiedot poistettiin oman turvallisuutesi vuoksi.",
            b: () => "Jos olit täyttänyt jotain tietoja, kaikki tiedot poistettiin oman turvallisuutesi vuoksi."
          },
          close: () => "Sulje"
        }
      }
    }
  },
  sv: {
    info: {
      body: () => "Berätta för oss om dina erfarenheter av våra tjänster. På så vis hjälper du oss att utveckla tjänsterna.",
      alert: {
        row: {
          "1": () => "Observera att feedbackformuläret inte hanterar uppdrag eller förfrågningar relaterade till personlig service eller förfrågningar.",
          "2": () => "Hjälp med personliga bank- eller försäkringsärenden"
        }
      },
      list: {
        item1: () => "Förmedla ditt tack.",
        item2: () => "Ditt utvecklingsförslag.",
        item3: () => "Vad kunde vi göra bättre?"
      }
    },
    login: {
      body: () => "Behandlingen av din respons går smidigare om du loggar in innan du ger respons.",
      link: () => "Logga in i tjänsten och ge respons"
    },
    feedback: {
      header: () => "Respons",
      body: () => "Alla punkter är obligatoriska, om inget annat anges.",
      form: {
        type: {
          label: () => "Responstyp",
          options: {
            positive: () => "Tack",
            negative: () => "Klagomål",
            development_proposal: () => "Utvecklingsförslag"
          },
          error: {
            empty: () => "Välj typ av respons."
          }
        },
        text: {
          label: () => "Respons",
          error: {
            empty: () => "Skriv din respons."
          },
          placeHolder: () => "Observera att återkopplingsformuläret inte hanterar uppdrag relaterade till personliga transaktioner eller förfrågningar"
        },
        contactCustomer: {
          form: {
            label: () => "Kontaktuppgifter"
          },
          label: () => "Jag vill bli kontaktad gällande min respons",
          hint: () => "Vi använder din kontaktinformation endast för kommunikation i anslutning till responsen, inte för marknadsföring."
        },
        contactMethod: {
          label: () => "Välj kontaktsätt",
          options: {
            phone: () => "Per telefon",
            email: () => "Per e-post",
            web_message: () => "Meddelande via OP:s tjänst"
          }
        },
        phone: {
          label: () => "Telefonnummer",
          hint: () => "Skriv ditt telefonnummer utan mellanslag. Kom ihåg landskoden, om du har ett utländskt abonnemang.",
          error: {
            empty: () => "Skriv telefonnumret.",
            invalid: () => "Kontrollera telefonnumret."
          }
        },
        email: {
          label: () => "E-postadress",
          error: {
            empty: () => "Skriv e-postadressen.",
            invalid: () => "Kontrollera e-postadressen."
          }
        },
        reachability: {
          label: () => "När är du bäst anträffbar?"
        },
        customerInfo: {
          label: () => "Jag vill lämna mina namn- och adressuppgifter för att min respons ska kunna behandlas smidigare"
        },
        name: {
          label: () => "Namn",
          error: {
            empty: () => "Skriv namnet.",
            invalid: () => "Kontrollera namnet."
          }
        },
        address: {
          label: () => "Adress",
          error: {
            empty: () => "Skriv adressen.",
            invalid: () => "Kontrollera adressen."
          }
        },
        postalCode: {
          label: () => "Postnummer",
          error: {
            empty: () => "Skriv postnumret.",
            invalid: () => "Kontrollera postnumret."
          }
        },
        moreInformation: {
          label: () => "tilläggsuppgifter"
        },
        target: {
          label: () => "Responsen gäller",
          option: {
            "default": () => "- Välj -",
            banking: () => "Banktjänster",
            insurance: () => "Försäkringstjänster",
            other: () => "Annat ärende"
          },
          error: {
            empty: () => "Välj vilket slags ärende responsen gäller."
          }
        },
        subject: {
          label: () => "Område",
          option: {
            "default": () => "- Välj -",
            accounts_cards_payments: () => "Konton, kort och betalningar",
            customer_feedback_loans_finance: () => "Lån och finansieringstjänster",
            customer_feedback_saving_investing: () => "Sparande och placering",
            customer_service: () => "Kundtjänsten",
            customer_feedback_mobile_service: () => "Mobiltjänsten",
            customer_feedback_web_service: () => "Nättjänsten",
            communication_marketing: () => "Kommunikation och marknadsföring",
            customer_feedback_proprietary: () => "Ägarkundskapet",
            customer_feedback_insurance_damage: () => "Försäkringar och skador",
            other: () => "Annat",
            customer_feedback_insurance_sales_customer_service: () => "Försäkringsförsäljning och transaktioner",
            customer_feedback_claims_indemnities: () => "Försäkringsanspråk och ersättning",
            customer_feedback_insurance_saving: () => "Försäkringssparande, liv- och pensionsförsäkring"
          },
          error: {
            empty: () => "Välj område."
          }
        },
        textArea: {
          error: {
            title: () => "Kontrollera stavningen. ",
            text: () => "Tillåtna tecken är bokstäverna Aa–Öö, siffrorna 0–9 och specialtecknen . , : ? ! ' \" + - & / ( )"
          },
          srError: {
            text: () => "Tillåtna tecken är de stora och små bokstäverna från a till ö, siffrorna från 0 till 9 och specialtecknen punkt, komma, kolon, frågetecken, utropstecken, apostrof, citattecken, plustecken, streck, et-tecken, snedstreck och parentes."
          }
        },
        optional: () => "(frivillig)",
        send: () => "Sänd",
        error: {
          row1: () => "Sändningen lyckades inte.",
          row2: () => "Var god och försök på nytt."
        },
        quit: {
          button: () => "Avbryt",
          modal: {
            title: () => "Vill du avbryta?",
            body: () => "Om du avbryter, sparas inte de uppgifter som du gett.",
            button: {
              quit: () => "Avbryt",
              cancel: () => "Tillbaka"
            }
          }
        }
      },
      sensitiveInfo: {
        unidentifiedCustomer: () => "Skriv inte personliga uppgifter i responsen. Sådana är till exempel personbeteckning, användarkoder, kontonummer, kortnummer och hälsouppgifter.",
        identifiedCustomer: () => "Skriv inte personliga uppgifter i responsen. Sådana är till exempel personbeteckning, användarkoder, kortnummer och hälsouppgifter."
      },
      errorSummary: {
        title: (d) => plural(d.count, 0, sv, { one: "Kontrollera och rätta följande fält", other: "Kontrollera och rätta följande " + d.count + " fält" })
      }
    },
    thanks: {
      title: () => "Tack för din respons!",
      body: () => "Vi behandlar din respons så fort som möjligt och tar kontakt med dig om du har önskat det.",
      feedbackId: (d) => "Om du vill kan du spara numret på responsen: " + d.feedbackId + ".",
      link: () => "Gå till ingångssidan för op.fi"
    },
    quit: {
      title: () => "Du avbröt ifyllningen av blanketten",
      body: () => "De uppgifter som du angett har inte sparats.",
      link: {
        frontpage: () => "Gå till ingångssidan för op.fi",
        giveFeedback: () => "Gå till sidan Ge respons"
      }
    },
    error: {
      title: () => "Störning i tjänsten, vi beklagar",
      body: () => "De går inte att ge respons just nu. Försök på nytt om en stund.",
      link: {
        form: () => "Försök ge respons på nytt",
        frontpage: () => "Gå till ingångssidan för op.fi",
        reportProblem: () => "Anmäl problem"
      }
    },
    url: {
      thanks: () => "/tack-for-aterkoppling",
      error: () => "/fel",
      quit: () => "/avbruten",
      opfi: {
        person: () => "/auth/dagliga-penningaffarer",
        business: () => "/web/corp/auth/ingangssidan",
        tupas: () => "/auth/dagliga-penningaffarer",
        unidentified: () => ""
      },
      form: {
        person: () => "/auth/kundtjanst/ge-respons",
        tupas: () => "/auth/kundtjanst/ge-respons",
        unidentified: () => "/privatkunder/kundtjanst/ge-respons",
        business: () => "/web/corp/auth/kundtjanst/respons"
      },
      reportProblem: {
        person: () => "/auth/kundtjanst/anmal-problem",
        tupas: () => "/auth/kundtjanst/anmal-problem",
        unidentified: () => "/privatkunder/kundtjanst/anmal-problem",
        business: () => "/web/corp/auth/kundtjanst/anmal-problem"
      },
      giveFeedback: {
        person: () => "/auth/kundtjanst/respons-och-problem",
        business: () => "/web/corp/auth/kundtjanst/respons-och-problem",
        unidentified: () => "/privatkunder/kundtjanst/respons-och-problem",
        tupas: () => "/auth/kundtjanst/respons-och-problem"
      }
    },
    session: {
      "continue": {
        modal: {
          title: () => "Vill du fortsätta använda tjänsten?",
          text: () => "Om du inte vill fortsätta men redan hann fylla i uppgifter, raderar vi av säkerhetsskäl alla uppgifter.",
          ok: () => "Fortsätt använda tjänsten",
          cancel: () => "Sluta använda tjänsten"
        }
      },
      dataDeleted: {
        modal: {
          title: () => "Sessionen avbröts",
          text: {
            a: () => "Eftersom du inte använt tjänsten på en stund, avbröts din session. Om du hade fyllt i uppgifter, raderades alla uppgifter av säkerhetsskäl.",
            b: () => "Om du hade fyllt i uppgifter, raderades alla uppgifter av säkerhetsskäl."
          },
          close: () => "Stäng"
        }
      }
    }
  }
}